import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

// 结算数据编辑组件
import { mapState } from 'vuex';
import SettlementInfo from './create/settlement';
import settlementFormItemMixin from './create/settlement-form-item-mixin';
import demandMixin from './create/demand-mixin';

export default {
  mixins: [demandMixin, settlementFormItemMixin],

  components: {
    SettlementInfo: SettlementInfo
  },

  data: function data() {
    return {
      formConfig: {
        labelWidth: '140px'
      }
    };
  },


  computed: _extends({}, mapState({
    payment: function payment(state) {
      return state.demand.payment;
    }
  }), {
    demand: function demand() {
      return this.$store.state.demand.payment.info;
    },
    submitButton: function submitButton() {
      return {
        type: 'primary',
        loading: this.payment.loading
      };
    },
    dialog: function dialog() {
      var _this = this;

      return _extends({
        beforeClose: function beforeClose(done) {
          if (_this.payment.loading) {
            _this.$message.info('提交数据中，暂无法关闭弹窗');
          } else {
            done();
          }
        }
      }, this.payment.dialog);
    },


    visible: {
      get: function get() {
        return this.dialog.visible;
      },
      set: function set(val) {
        var _this2 = this;

        return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(val === false && _this2.$refs.form)) {
                    _context.next = 4;
                    break;
                  }

                  _context.next = 3;
                  return _this2.$store.dispatch('demand/payment/resetInfo');

                case 3:
                  _this2.$refs.form.clearValidate();

                case 4:
                  if (!(val === false)) {
                    _context.next = 9;
                    break;
                  }

                  _context.next = 7;
                  return _this2.$store.dispatch('demand/payment/closeDialog');

                case 7:
                  _context.next = 11;
                  break;

                case 9:
                  _context.next = 11;
                  return _this2.$store.dispatch('demand/payment/openDialog');

                case 11:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }))();
      }
    }
  }),

  methods: {
    submit: function submit() {
      var _this3 = this;

      this.$refs.form.validate(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(valid) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 17;
                    break;
                  }

                  _context2.prev = 1;

                  _this3.$store.commit('demand/payment/updateLoading', true);
                  _context2.next = 5;
                  return _this3.$store.dispatch('demand/payment/updateInfo', _this3.demand);

                case 5:
                  _context2.next = 7;
                  return _this3.$store.dispatch('demand/payment/update');

                case 7:
                  _this3.visible = false;
                  _this3.$emit('save-success');
                  _context2.next = 14;
                  break;

                case 11:
                  _context2.prev = 11;
                  _context2.t0 = _context2['catch'](1);

                  console.log(_context2.t0);

                case 14:
                  _context2.prev = 14;

                  _this3.$store.commit('demand/payment/updateLoading', false);
                  return _context2.finish(14);

                case 17:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this3, [[1, 11, 14, 17]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    openDialog: function openDialog() {
      this.visible = true;
    },
    closeDialog: function closeDialog() {
      this.visible = false;
    }
  }
};